<template>
  <div class="loginContainer" ref="loginContainer">
    <img
      src="../../assets/icon_back.png"
      style="width:4rem;height:4rem;position:fixed;top:0;left:3rem;cursor: pointer;"
      @click="$router.back()"
    />
    <div style="height:3.5rem"></div>
    <div class="studentContainer">
      <div
        style="width:100%;height:100%;background:#ffffff;border-radius:2rem;"
      >
        <div
          style="height:4rem;width:100%;text-align:center;line-height:4rem;position:relative;background: #CFEEFF;border-radius: 2rem 2rem 0px 0px;font-size: 2rem;color: #0F85DB;"
        >
          {{ class_name }}
          <div
            v-if="students.length > 0"
            style="cursor: pointer; width: 8.7rem;height: 2.8rem;line-height:2.8rem;background: #FF666D;border-radius: 1.4rem;font-size: 1.4rem;color: #FFFFFF;position:absolute;right:1rem;top:0.6rem"
            @click="showRankList"
          >
            排行榜
          </div>
        </div>
        <div
          v-if="students.length > 0 && loaded"
          style="height:calc( 100% - 4rem );border-radius:2rem;overflow:scroll"
          ref="bScroll"
          class="bScroll"
        >
          <div
            style="padding:1rem;display: grid;grid-template-columns: 1fr 1fr 1fr 1fr;grid-column-gap: 1rem;"
            ref="scrollContainer"
          >
            <div
              v-for="(item, index) in students.filter((item) => {
                return item.is_signin == 1
              })"
              :key="'sign' + index"
            >
              <div
                style="width:18.75rem;height:11.4rem;border-radius:1rem;margin-bottom:1rem;"
                :class="item.is_signin == '1' ? 'singInBg' : 'unSingInBg'"
              >
                <div
                  style="height:6.1rem;padding-left:1rem;padding-top:1.1rem;"
                  class="flexAc"
                >
                  <div
                    style="background: linear-gradient(0deg, #50B8EF 0%, #16A0E9 100%);border-radius: 50%;height:6.1rem;width:6.1rem"
                    class="flexCenter"
                    @click="signIn(item.id)"
                  >
                    <img
                      :src="
                        item.avatar
                          ? item.avatar
                          : require('../../assets/default_avatar.png')
                      "
                      style="cursor: pointer;width:5.5rem;height:5.5rem;border-radius:50%"
                      :style="
                        item.is_signin == '1' ? '' : 'filter: grayscale(100%);'
                      "
                    />
                  </div>
                  <div style="width:11rem;text-align:right">
                    <div
                      style="font-size: 1.4rem;color: #0F85DB;height:2.5rem;line-height:2.5rem;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                    >
                      {{ item.nickname }}
                    </div>
                    <div style="border: 1px solid #0F85DB;opacity: 0.2;"></div>
                    <div
                      class="flexAc"
                      style="justify-content: space-between;height:2.5rem;"
                    >
                      <div
                        v-if="item.is_open == '0'"
                        style="font-size:1rem;color:#ffffff;background:#bababa;border-radius:20px;padding:2px 5px"
                      >
                        未开通
                      </div>
                      <div v-else></div>
                      <div class="flexAc">
                        <img
                          src="../../assets/icon_coin.png"
                          style="width:1.8rem;height:1.8rem;margin-right:0.5rem"
                        />
                        <div style="font-size: 1.4rem;color: #0F85DB;">
                          {{ item.coin_num }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="margin-top:0.6rem;padding:0rem 2rem"
                  class="flexBetween"
                >
                  <div
                    class="loginBtn"
                    @click="
                      $router.push(
                        '/task_list?nickname=' +
                          encodeURIComponent(item.nickname) +
                          '&class_id=' +
                          $route.query.id +
                          '&student_id=' +
                          item.id
                      )
                    "
                  >
                    作品
                  </div>
                  <div
                    class="sendSmsBtn flexCenter"
                    style="position:relative"
                    :style="item.is_open == 0 ? 'filter: grayscale(100%);' : ''"
                    @click="startConfetti($event, item.id, item.is_open)"
                  >
                    <img
                      :src="
                        item.is_reward == 0
                          ? require('../../assets/icon_star_white.png')
                          : require('../../assets/icon_star_red.png')
                      "
                      style="width:1.4rem"
                    />
                    <div
                      v-if="item.is_reward > 0"
                      style="width: 2.4rem;height: 2.4rem;background: #FFFFFF;border: 0.1rem solid #F04653;border-radius: 50%;
                    position:absolute;top:-1.2rem;right:-1.2rem;color:#F04652;font-size:1.2rem"
                    >
                      +{{ item.is_reward }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="(item, index) in students.filter((item) => {
                return item.is_signin == 0
              })"
              :key="'unsign' + index"
              style="cursor: pointer"
              @click="signIn(item.id)"
            >
              <div
                style="width:18.75rem;height:11.4rem;border-radius:1rem;margin-bottom:1rem;"
                :class="item.is_signin == '1' ? 'singInBg' : 'unSingInBg'"
              >
                <div
                  style="height:6.1rem;padding-left:1rem;padding-top:1.1rem;"
                  class="flexAc"
                >
                  <div
                    style="background: #999999;border-radius: 50%;height:6.1rem;width:6.1rem"
                    class="flexCenter"
                  >
                    <img
                      :src="
                        item.avatar
                          ? item.avatar
                          : require('../../assets/default_avatar.png')
                      "
                      style="cursor: pointer;width:5.5rem;height:5.5rem;border-radius:50%"
                      :style="
                        item.is_signin == '1' ? '' : 'filter: grayscale(100%);'
                      "
                    />
                  </div>
                  <div style="width:11rem;text-align:right">
                    <div
                      style="font-size: 1.4rem;color: #0F85DB;height:2.5rem;line-height:2.5rem;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                    >
                      {{ item.nickname }}
                    </div>
                    <div style="border: 1px solid #0F85DB;opacity: 0.2;"></div>
                    <div
                      class="flexAc"
                      style="justify-content: space-between;height:2.5rem;"
                    >
                      <div
                        v-if="item.is_open == '0'"
                        style="font-size:1rem;color:#ffffff;background:#bababa;border-radius:20px;padding:2px 5px"
                      >
                        未开通
                      </div>
                      <div v-else></div>
                      <div class="flexAc">
                        <img
                          src="../../assets/icon_coin.png"
                          style="width:1.8rem;height:1.8rem;margin-right:0.5rem"
                        />
                        <div style="font-size: 1.4rem;color: #0F85DB;">
                          {{ item.coin_num }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="margin-top:0.6rem;padding:0rem 2rem"
                  class="flexBetween"
                >
                  <div
                    class="loginBtn"
                    @click.stop="
                      $router.push(
                        '/task_list?nickname=' +
                          encodeURIComponent(item.nickname) +
                          '&class_id=' +
                          $route.query.id +
                          '&student_id=' +
                          item.id
                      )
                    "
                  >
                    作品
                  </div>
                  <div
                    class="sendSmsBtn flexCenter"
                    style="position:relative;filter: grayscale(100%);"
                    @click.stop=""
                  >
                    <img
                      :src="
                        item.is_reward == 0
                          ? require('../../assets/icon_star_white.png')
                          : require('../../assets/icon_star_red.png')
                      "
                      style="width:1.4rem"
                    />
                    <div
                      v-if="item.is_reward > 0"
                      style="width: 2.4rem;height: 2.4rem;background: #FFFFFF;border: 0.1rem solid #F04653;border-radius: 50%;
                    position:absolute;top:-1.2rem;right:-1.2rem;color:#F04652;font-size:1.2rem"
                    >
                      +{{ item.is_reward }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="students.length == 0 && loaded"
          style="height:calc( 100% - 4rem );border-radius:2rem;overflow:hidden"
          class="flexCenter"
        >
          <div
            style="width:32rem;height:31rem;font-size:1.4rem;color:#0F85DB;position:relative;overflow:hidden;margin-top:11rem"
          >
            <img src="../../assets/students_nodata.png" style="width:100%;" />
            <div
              style="position:absolute;width:100%;height:100%;top:0;left:0"
              class="flexCenter"
            >
              暂无学员信息
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-bar
      @startClass="$router.push('/start_class?class_id=' + $route.query.id)"
      right-bar="startClass"
    ></bottom-bar>
    <div
      style="width:50%;position:fixed;bottom:2.6rem;left:25%"
      class="flexCenter"
    >
      <div>
        <img
          src="../../assets/class_arrow_up.png"
          style="width:3.6rem;cursor: pointer;"
          @click="scrollPrev('bScroll')"
        />
        <img
          src="../../assets/class_arrow_down.png"
          style="width:3.6rem;margin-left:2.5rem;cursor: pointer;"
          @click="scrollNext('bScroll')"
        />
      </div>
    </div>
    <!--        <div style="position:fixed;bottom:4.4rem;right:0.1rem;cursor: pointer;"-->
    <!--             @click="$router.push('/start_class?class_id='+$route.query.id)">-->
    <!--            <img src="../../assets/icon_start_class.png" style="width:7.15rem"/>-->
    <!--        </div>-->
    <rank-list ref="rank-list"></rank-list>

    <audio
      src="https://open.xiaobixiezi.com/h5/icon/MP3/lqcoins.mp3"
      :autoplay="false"
      :loop="false"
      :preload="true"
      style="width:0px;height:0px"
      ref="my-audio"
    ></audio>
  </div>
</template>

<script>
import BottomBar from '../../components/BottomBar.vue'
import RankList from '../../components/RankList.vue'

export default {
  name: 'StudentList',
  components: {
    BottomBar,
    RankList,
  },
  data() {
    return {
      loaded: false,
      class_name: '',
      scrollOffset: 0,
      bScroll: null,
      scrollHeight: '100%',
      students: [],
    }
  },
  mounted() {
    this.initData()
  },
  destroyed() {
    if (this.bScroll) {
      this.bScroll.destroy()
    }
  },
  methods: {
    initData() {
      this.$http
        .post('/api/v2/handwriting/BigScreen/get_class_student_list', {
          class_id: this.$route.query.id,
        })
        .then((res) => {
          if (res.code == '200') {
            this.class_name = res.data.class_name
            let list = res.data.list
            this.students = list || []
            this.loaded = true
            this.$nextTick(() => {
              this.$refs['bScroll'].addEventListener('scroll', (e) => {
                this.scrollOffset = e.target.scrollTop
              })
            })
          }
        })
    },
    startConfetti(e, id, is_open) {
      if (is_open == '1') {
        this.$http
          .post('/api/v2/handwriting/BigScreen/student_reward', {
            class_id: this.$route.query.id,
            student_id: id,
          })
          .then((res) => {
            if (res.code == '200') {
              this.$refs['my-audio'].currentTime = 0
              this.$refs['my-audio'].play()
              let idx = this.students.findIndex((item) => {
                return item.id == id
              })

              let target = e.target
              if (target.classList.toString().indexOf('sendSmsBtn') < 0) {
                target = e.target.parentNode
              }
              let rewardDiv = document.createElement('div')
              rewardDiv.classList = 'rewardStar'
              rewardDiv.innerHTML =
                '<img src="' +
                require('../../assets/reward_star.png') +
                '" style="width:10rem;height:10rem"/>'
              let container = document.querySelector('.loginContainer')
              container.appendChild(rewardDiv)
              let imgObj = rewardDiv.querySelector('img')

              let clientRect = target.getBoundingClientRect()
              setTimeout(() => {
                rewardDiv.style.top = clientRect.top + 'px'
                rewardDiv.style.left = clientRect.left + 'px'
                imgObj.style.width = '1.4rem'
                imgObj.style.height = '1.4rem'
                imgObj.style.marginLeft = '2.7rem'
                imgObj.style.marginTop = '0.5rem'
              }, 2000)

              setTimeout(() => {
                container.removeChild(rewardDiv)
                this.students[idx].is_reward = this.students[idx].is_reward + 1
              }, 4000)
            }
          })
      }
    },
    signIn(id) {
      this.$http
        .post('/api/v2/handwriting/BigScreen/student_signin', {
          class_id: this.$route.query.id,
          student_id: id,
        })
        .then((res) => {
          if (res.code == '200') {
            let idx = this.students.findIndex((item) => {
              return item.id == id
            })
            if (this.students[idx].is_signin == '1') {
              this.students[idx].is_signin = '0'
            } else {
              this.students[idx].is_signin = '1'
            }
          }
        })
    },
    showRankList() {
      this.$refs['rank-list'].show(this.$route.query.id)
    },
    scrollPrev(pref) {
      let pobj = this.$refs[pref]
      let ph = pobj.offsetHeight

      let targetY = 0
      if (this.scrollOffset <= ph) {
        targetY = 0
      } else {
        targetY = this.scrollOffset - ph
      }
      pobj.scrollTo(0, targetY)
      // scrollX(pobj,this.scrollOffset, targetX)
      this.scrollOffset = targetY
    },
    scrollNext(pref) {
      let pobj = this.$refs[pref]
      let ph = pobj.offsetHeight
      let sh = pobj.scrollHeight

      let targetY = 0
      if (this.scrollOffset + ph >= sh) {
        targetY = sh - ph
      } else {
        targetY = this.scrollOffset + ph
      }
      pobj.scrollTo(0, targetY)
      // scrollX(pobj,this.scrollOffset, targetX)
      this.scrollOffset = targetY
    },
  },
}
</script>
<style scoped>
.singInBg {
  background: #cfeeff;
}

.unSingInBg {
  background: #eeeeee;
}

.swiper-slide {
  flex-shrink: 1;
}

.loginContainer {
  width: 100vw;
  height: 100vh;
  background: url('../../assets/class_bg.png') no-repeat;
  background-size: 100% 100%;
}

.studentContainer {
  width: 80rem;
  height: calc(100vh - 10.4rem);
  padding: 0.5rem;
  margin: 0 auto;
  background: linear-gradient(
    to bottom right,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 0.7) 100%
  );
  border-radius: 2rem;
}

.sendSmsBtn {
  cursor: pointer;
  width: 6.8rem;
  height: 2.4rem;
  line-height: 2.4rem;
  text-align: center;
  font-size: 1.4rem;
  border-radius: 1.2rem;
  color: #ffffff;
  background: linear-gradient(to right, #ffa143, #ffc11d);
}

.sendSmsBtn:hover {
  background: linear-gradient(to right, #f38b22, #f38b22);
}

.loginBtn {
  cursor: pointer;
  width: 6.8rem;
  height: 2.4rem;
  line-height: 2.4rem;
  text-align: center;
  font-size: 1.4rem;
  border-radius: 1.2rem;
  color: #ffffff;
  background: #2a9bff;
}
.bScroll::-webkit-scrollbar {
  display: none;
}

.loginBtn:hover {
  background: #158ffa;
}

.classContainer {
  width: 200%;
  position: absolute;
  top: 0;
  left: -50%;
  background: red;
  overflow: hidden;
  border-radius: 0 0 50% 50%;
  background: linear-gradient(
    0deg,
    rgba(15, 133, 219, 0.25) 0%,
    rgba(255, 255, 255, 0) 30%,
    rgba(255, 255, 255, 0) 100%
  );
}
</style>
